export const getAgentList = state => state.livemonitorReducer.agentList;
export const getFilter = state => state.livemonitorReducer.filter;
export const getStateList = state => state.livemonitorReducer.stateList;
export const getQueue = state => state.livemonitorReducer.queue;

export const getLiveDynamic = (state, options) => {
  return options.key ?  state.livemonitorReducer[options.key] || ""  : ""
};
export const getSingleAgentList = (state, options) => { options.key ?  state.livemonitorReducer.agentList[options.key] || ""  : ""};
export const getSingleFilter = (state, options) => { options.key ?  state.livemonitorReducer.filter[options.key] || ""  : ""};
export const getSingleStateList = (state, options) => { options.key ?  state.livemonitorReducer.stateList[options.key] || ""  : ""};
export const getSingleQueue = (state, options) => { options.key ?  state.livemonitorReducer.queue[options.key] || ""  : ""};


// WEBPACK FOOTER //
// ./src/store/selector/livemonitor.selector.js